import React, { Component } from "react";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { connect } from "react-redux";
import { Collapse, CardBody, Card } from "reactstrap";
import style from "./AppoinmentList.module.css";
import { fetchAppointmentList, 
  fetchDropdownList, 
  fetchAppointmentDetails, 
  fetchAppointmentDropdown } from "../../redux";
import { fetchAdvFilteList } from "../../redux";
import filterImage from "../../assets/images/advanced-filter-icon.svg";
import ttmLodader from "../../assets/images/ttm-loader.gif";
import api from "../../utils/Api";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";
import { DatePicker } from "antd";
import moment from 'moment';
import { firstLetterCapital } from "../../utils/CommonUtil";
import history from "../../utils/history";
/**
 * This function will format the date.
 * @param {date} cell
 */
function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}
export class AppoinmentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filterOption: "all",
      searchKey: "",
      sortBy: "",
      page: 1,
      sortName: undefined,
      sortOrder: undefined,
      isDataFetched: false,
      lk_appointment_status_id:"",
      isTodaysAppointmentist: "",
      isWaitingList: "",
      filterBy: "",
      advFilterDropdownData: "",
      filter_name: "",
      filterError: "",
      queryString: "",
      advQueryString: "",
      dateFrom: "",
      dateTo: "",
      appointmentList:[],
      isDeleteModalOpen: "",
      errorResponse: "",
      isModalOpenAppointment: false,
      isAppointmentModalLoading: false,
      isCaseFileDownloading: false,
      outstandingInvoices:"",
      pastAppointmentCount:""
    };
    this.setLoader = this.setLoader.bind(this);
  }

  
  /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
      dateFrom: dateFormatter(this.state.dateFrom),
      dateTo: dateFormatter(this.state.dateTo),
    };
  };

  componentDidMount = async() =>{
    document.title = 'Appointments - TechToMedix';
    this.props.fetchAppointmentDropdown();
   if(this.props.location && 
      this.props.location.params && 
      this.props.location.params.lk_appointment_status_id ){
        this.setState({
          lk_appointment_status_id: this.props.location.params.lk_appointment_status_id
        })
      }
      if(this.props.location && 
        this.props.location.params && 
        this.props.location.params.isTodaysAppointmentist ){
          this.setState({
            isTodaysAppointmentist: this.props.location.params.isTodaysAppointmentist
          })
        }
        if(this.props.location && 
          this.props.location.params && 
          this.props.location.params.isWaitingList ){
            this.setState({
              isWaitingList: this.props.location.params.isWaitingList
            })
          }
          if(this.props.location && 
            this.props.location.params && 
            this.props.location.params.outstandingInvoices){
              this.setState({
                outstandingInvoices: this.props.location.params.outstandingInvoices
              })
            }          
            if(this.props.location && 
              this.props.location.params && 
              this.props.location.params.pastAppointmentCount){
                this.setState({
                  pastAppointmentCount: this.props.location.params.pastAppointmentCount
                })
              }          
        const payload = this.getPayload();
   await this.props.fetchDropdownList();
    await this.props.fetchAppointmentList(
      payload,
      this.state.searchKey,
      this.state.sortBy,
      this.state.page,
      this.state.lk_appointment_status_id,
      this.state.isTodaysAppointmentist,
      this.state.isWaitingList,      
      this.state.outstandingInvoices,
      this.state.pastAppointmentCount
    );

    if(this.props.appointmentListData && 
      this.props.appointmentListData.appointmentList && 
      this.props.appointmentListData.appointmentList.appointment){

        this.setState({
          appointmentList: this.props.appointmentListData.appointmentList.appointment
        })
    }
    // calling method for getting filter list
    // this.getFiltercolumnData();
    // this.props.fetchAppointmentList("", this.state.sortBy, this.state.page);

    setTimeout(() => {
      if (this.props.appointmentListData.appointmentList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
        setTimeout(() => {
          this.setState({
            isDataFetched: true,
          });
        }, 500);
      }
    }, 1000);
  }

  callAppointmentList = async() => {
    this.setState({
      appointmentList: [],
    })
    const payload = this.getPayload();
    if (this.state.advQueryString !== "") {
      let queryString = this.state.queryString + this.state.advQueryString;
      await this.props.fetchAppointmentList(
        payload,
        queryString,
        this.state.sortBy,
        this.state.page,
        this.state.lk_appointment_status_id,
        this.state.isTodaysAppointmentist,
        this.state.isWaitingList, 
        this.state.outstandingInvoices,
        this.state.pastAppointmentCount
      );
    } else {
      await this.props.fetchAppointmentList(
        payload,
        this.state.queryString,
        this.state.sortBy,
        this.state.page,
        this.state.lk_appointment_status_id,
        this.state.isTodaysAppointmentist,
        this.state.isWaitingList, 
        this.state.outstandingInvoices,
        this.state.pastAppointmentCount
      );
    }
    if(!this.props.appointmentListData.loading){

      setTimeout(() => {
      this.setState({
        appointmentList: this.props.appointmentListData.appointmentList.appointment
      })
        this.setState({
          isDataFetched: true,
        });
    }, 1000);
    }
  }

  clearFilters = () => {
    this.setState({
      searchKey: "",
      sortBy: "",
      filterOption: "all",
      queryString: "",
      advQueryString: "",
      lk_appointment_status_id:"",
      filterBy: "",
      filter_name: "",
      filterError: "",
      dateFrom: "",
      dateTo: "",
      page: 1,
      isDataFetched: false
    },()=>{
      this.callAppointmentList();
    });
  }

  // method declaration
  toggle = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));

    // Fetching advanced filter dropdwon values
    if (!this.state.isOpen) {
      this.props.fetchAdvFilteList();
    } else {
      this.setState({
        filterBy: "",
        filter_name: "",
        filterError: "",
        filterOption: "all",
        advQueryString:"",
        page: 1,
        isDataFetched: false
      },()=>{
        this.callAppointmentList();
      });
    }
  };

  // toggle modal poup for delete appointment from list
  toggleDeleteModal = (val) => {
    this.setState((prevState) => ({
      appointment_id: val.appointment_id,
      errorMessage: "",
      isDeleteModalOpen: !prevState.isDeleteModalOpen,
    }));
  };

  handleOptionChange = (changeEvent) => {
    this.setState(
      {
        filterBy: changeEvent.target.value,
      },
      () => {
        if (this.state.filterBy === "scheduler") {
          const schedularFilterData =
            this.props.advFilterListData.AdvFilterList &&
            this.props.advFilterListData.AdvFilterList.scheduler;
          console.log("************schedularFilterData", schedularFilterData);
          this.setState({
            advFilterDropdownData: schedularFilterData,
            filterError: "",
          });
        } else if(this.state.filterBy === "doctor_name") {
          const professionalFilterData =
            this.props.advFilterListData.AdvFilterList &&
            this.props.advFilterListData.AdvFilterList.requestedProfessional;
          this.setState({
            advFilterDropdownData: professionalFilterData,
            filterError: "",
          });
        } else if(this.state.filterBy === "room_name") {
          const roomFilterData =
            this.props.advFilterListData.AdvFilterList &&
            this.props.advFilterListData.AdvFilterList.room;
          this.setState({
            advFilterDropdownData: roomFilterData,
            filterError: "",
          });
        }
      }
    );
  };

  // advanced filter select name change
  nameOnChnage = (event) => {
    this.setState({
      filter_name: event.target.value,
      filterError: "",
    });
  };

  
  /**
   * This method will be called when date from filter is changed.
   */
  handleDateFrom = (date) => {

    this.setState(
      {
        dateFrom: date,
        page: 1,
        isDataFetched: false
      },()=>{
        this.callAppointmentList();
      }
    );
  };

  /**
   * This method will be called when date to filter is changed.
   */
  handleDateTo = (date) => {
  
    this.setState(
      {
        dateTo: date,
        page: 1,
        isDataFetched: false
      },()=>{
        this.callAppointmentList();
      }
    );
  };

  // advance filter submit
  advFilterSubmit = () => {
    if (this.state.filterBy === "") {
      this.setState({
        filterError: "Please select a filter!",
      });
    } else if (this.state.filter_name === "") {
      this.setState({
        filterError: "Filter name is required",
      });
    } else {
      this.setState({
        filterError: "",
      });
      // let queryString;
      // switch (this.state.filterBy) {
      //   case "scheduler":
      //     queryString = "scheduler=" + this.state.filter_name;
      //     break;
      //   case "doctor_name":
      //     queryString = "doctor_id=" + this.state.filter_name;
      //     break;
      // }
      let advQueryString;
      switch (this.state.filterBy) {
        case "scheduler":
          advQueryString = "&scheduler=" + this.state.filter_name;
          break;
        case "doctor_name":
          advQueryString = "&doctor_id=" + this.state.filter_name;
          break;
          case "room_name":
            advQueryString = "&room_id=" + this.state.filter_name;
            break;
            default: 
            break;
      }
      this.setState(
        {
          advQueryString: advQueryString,
          page: 1,
          isDataFetched: false
        },
        ()=>{
          this.callAppointmentList();
        }
        // () => {
        //   const queryString =
        //     this.state.queryString + "&" + this.state.advQueryString;
        //   this.props.fetchAppointmentList(queryString, this.state.sortBy, 1);
        // }
      );
    }
  };

  downloadFile = async (appointment_id, lk_document_type_id) => {
    let notesType =
      lk_document_type_id === 1
        ? "Doctor Note"
        : lk_document_type_id === 2
        ? "Referral Note"
        : "Prescription";
    this.setState({
      isCaseFileDownloading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      appointment_id: appointment_id,
      lk_document_type_id: lk_document_type_id,
    };

    try {
      const response = await api.post("appointment/notes/download", payload, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isCaseFileDownloading: false,
          successMessage: "Attached document download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${notesType}.pdf`);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isCaseFileDownloading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };
  
  // Download patient file
  onDownloadSubmitFile = async (appoinmentDetailsData) => {
    this.setState({
      isCaseFileDownloading: true,
    });

    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      patient_id:appoinmentDetailsData.associated_related_party_id,
    };

    try {
      const response = await api.post(
        "appointment/patientfile/download",
        payload,
        {
          headers: headers,
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        this.setState({
          isCaseFileDownloading: false,
          successMessage: "Patient file download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if(appoinmentDetailsData.file_number){
          link.setAttribute("download", `${appoinmentDetailsData.file_number}.pdf`);
        }else{
          link.setAttribute("download", `${appoinmentDetailsData.name}.pdf`);
        }
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isCaseFileDownloading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };


  nameFormatter(cell, row){
    if (!cell && !row.related_party_surname) return "Not Available";
    return ((cell ? (cell.charAt(0).toUpperCase() + cell.slice(1)): "") + " " +
    (row.related_party_surname ? (row.related_party_surname.charAt(0).toUpperCase() + row.related_party_surname.slice(1)):""))
  }

  appointmentDateFormatted(cell, row){
   return (cell && JSON.parse(cell) && moment(JSON.parse(cell)[0].bdate).format("YYYY-MM-DD"))||""
  }

  getRoom = (room_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.room.length > 0){
     let room = appointmentDropdownData.room.find((item)=>item.room_id === parseInt(room_id) )
     return (room && room.room_name) ? firstLetterCapital(room.room_name): "Not Available";
    }
    return "Not Available";
   }
   

  getRequestedProfessional = (requested_related_party_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.requestedProfessional.length > 0){
     let reqProf = appointmentDropdownData.requestedProfessional.find((item)=>item.related_party_id === parseInt(requested_related_party_id) )
     return (reqProf && reqProf.name) ? reqProf.name: "Not Available";
    }
    return "Not Available";
   }

   
  getAppointmentReason = (lk_appointment_reason_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.appointmentReason.length > 0){
     let obj = appointmentDropdownData.appointmentReason.find((item)=>item.lk_appointment_reason_id === parseInt(lk_appointment_reason_id) )
     return (obj && obj.appointment_reason) ? obj.appointment_reason: "Not Available";
    }
    return "Not Available";
   }

   getAppointmentStatus = (lk_appointment_status_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.appointmentStatus.length > 0){
     let obj = appointmentDropdownData.appointmentStatus.find((item)=>item.lk_appointment_status_id === parseInt(lk_appointment_status_id) )
     return (obj && obj.appointment_status) ? obj.appointment_status: "Not Available";
    }
    return "Not Available";
   }

  toggleAppointmentView = (val) => {
    this.setState((prevState) => ({
      isModalOpenAppointment: !prevState.isModalOpenAppointment,
      isAppointmentModalLoading: true
    }),async()=>{
      if(this.state.isModalOpenAppointment){
        await this.props.fetchAppointmentDetails(val.appointment_id);
        this.setState({
          isAppointmentModalLoading: false
        })
      }
    });
  };

  // Adding actions edit and delete icons
  actionsFormatter(cell, row) {
    return (
      <div>
        { checkIfPermitted(Permissions.EDIT_APPOINTMENT) && (
        <Link title="Edit Appointment" to={{ pathname: `/app/createappointment/${row.appointment_id}` }}>
          <i className="fa fa-pencil-square-o mr-3 relatedpartylist-edit-icon"></i>
        </Link>)}
        
        <Link title="View Appointment">
          <i
            class={`fa fa-eye ${style.contactView}`}
            onClick={() => this.toggleAppointmentView(row)}
          ></i>
        </Link>
       {  checkIfPermitted(Permissions.DELETE_APPOINTMENT) && ( 
        <Link title="Delete Appointment" 
            className="action-icons relatedpartylist-add-icon"
            onClick={() => this.toggleDeleteModal(row)}
          >
            <i className="fa fa-trash"></i>
          </Link>
        )}
      </div>
    );
  }

  selectChange = (event) => {
    let filterVal = event.target.value;
    this.setState({
      filterOption: filterVal,
      // searchKey: "",
    });
    let queryString;
    if (filterVal === "all") {
      queryString = "&search_key=" + this.state.searchKey;
    } else {
      queryString = `&${filterVal}=${this.state.searchKey}`;
    }
    this.setState({ 
      queryString,
      page: 1 ,
      isDataFetched: false
    },()=>{
      this.callAppointmentList();
    });

    //If advanced filter is there
    // if (this.state.advQueryString !== "") {
    //   let queryString =
    //     this.state.queryString + "&" + this.state.advQueryString;
    //   this.props.fetchAppointmentList(queryString, this.state.sortBy, 1);
    // } else {
    //   this.props.fetchAppointmentList(queryString, this.state.sortBy, 1);
    // }
  };

  selectAppointmentStatus = (event) => {
    let filterVal = event.target.value;
    this.setState({
      lk_appointment_status_id: filterVal, 
      page: 1, 
      isDataFetched: false
    },()=>{
     this.callAppointmentList();
    });

  }

  onSearchChange = (event) => {
    let searchText = event.target.value;
    this.setState({ searchKey: searchText, page: 1, isDataFetched: true });

    let queryString;
    switch (this.state.filterOption) {
      case "related_party_name":
        queryString = "&related_party_name=" + searchText;
        break;
      case "doctor_name":
        queryString = "&doctor_name=" + searchText;
        break;
      case "room_name":
        queryString = "&room_name=" + searchText;
        break;
      case "appointment_status":
        queryString = "&appointment_status=" + searchText;
        break;
      default:
        queryString = "&search_key=" + searchText;
    }
    this.setState({ 
      queryString ,
      page: 1,
      isDataFetched: false
    },()=>{
      this.callAppointmentList();
    });
    // this.props.fetchAppointmentList(queryString, this.state.sortBy, 1);

    //If advanced filter is there
    // if (this.state.advQueryString !== "") {
    //   let queryString =
    //     this.state.queryString + "&" + this.state.advQueryString;
    //   this.props.fetchAppointmentList(queryString, this.state.sortBy, 1);
    // } else {
    //   this.props.fetchAppointmentList(queryString, this.state.sortBy, 1);
    // }
  };

  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState({
      sortName,
      sortOrder,
      sortBy,
      page: 1,
      isDataFetched: false,
    },()=>{
      this.callAppointmentList();
    });
    //this.props.fetchAppointmentList(this.state.searchKey, sortBy, 1);
  };

  onPageChange = (page, sizePerPage) => {
    this.setState({
       page, 
       isDataFetched: false 
      }, () => {
            this.callAppointmentList();
    });
  };

  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLodader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  // API calling for delete appointment from appointment list
  onDeleteAppointment = async () => {
    try {
      const response = await api.delete("appointment", {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        },
        data: {
          appointment_id: this.state.appointment_id,
        },
      });
      console.log(
        "********** Appointment delete response **********",
        response
      );
      if (response.status === 200) {
        this.setState({
          successMessage: "Appointment deleted successfully!",
        });
        setTimeout(() => {
          this.setState((prevState) => ({
            successMessage: "",
            isDeleteModalOpen: !prevState.isDeleteModalOpen,
            isDataFetched: false
          }));
          this.callAppointmentList();
        }, 3000);
      }
    } catch (error) {
      //console.log("********** error **********", error.response.data.message);
      this.setState({
        errorMessage: error.response.data.message,
      });
      // setTimeout(() => {
      //   this.setState((prevState) => ({
      //     errorMessage: "",
      //     isDeleteModalOpen: !prevState.isDeleteModalOpen,
      //   }));
      // }, 2000);
    }
  };

  renderScheduledTime = (dateValue, timeValue) => {
    const datetime = new Date(dateValue);
    datetime.setHours(timeValue.split(":")[0]);
    datetime.setMinutes(datetime.getMinutes() + timeValue.split(":")[1]);
    return datetime.toLocaleTimeString();
  }

  renderScheduledDates = (appointment_date) => {
    let selectedDates = JSON.parse(appointment_date);
    if (selectedDates && selectedDates.length > 0) {
      return (
        <div className="">
          {selectedDates.map((date, index) => (
            <div key={index} className={style.inlineDateTimeInnerWrapper}>
              <span key={index} className={style.dateInfo}>
                {/* {date.toLocaleDateString()} {" - "} {date.toLocaleTimeString()} */}
                {/* {new Date(date.bdate).toLocaleDateString()}{" "} */}
                {moment(date.bdate).format("YYYY-MM-DD")}{" "}
                {this.renderScheduledTime(date.bdate, date.start)} {" - "}
                {this.renderScheduledTime(date.bdate, date.end)}
              </span>
            </div>
          ))}
        </div>
      );
    }else{
      return "";
    }
  }
  goBack = () => {
    history.goBack();
  }

  render() {
    const appoinmentList = this.props.appointmentListData.appointmentList;
    const appoinmentDetailsData = this.props.appointmentDetailsData && 
    this.props.appointmentDetailsData.appointmentDetails[0];
    // const advFilterList =
    //   this.props.advFilterListData && this.props.advFilterListData;
    // console.log("********* advFilterList in component", advFilterList);
    // getting dropdown list options from redux persist
    const dropdownData = this.props.dropdownListData.dropdownList;
    // getting category dropdwon options
    const appointmentStatusOptions =
    dropdownData && dropdownData.lk_appointment_status &&
     dropdownData.lk_appointment_status.map((element, index) => (
        <option key={index} value={element.lk_appointment_status_id}>
          {element.appointment_status}
        </option>
      ));

    return (
      <div className={style.appoListMainWarapper}>
         {this.props.location.state && 
      this.props.location.state.fromNotifications === 1 &&  ( 
        <div className="mb-2">
            <span className="goBackBtn" onClick={this.goBack}>
              <i class="fa fa-arrow-left" aria-hidden="true"></i>{" "}
              Go Back to Notifications</span>
          </div>)}
        <div className="row">
          <div className="col-md-6 order-1">
            <h3>Appointment List</h3>
          </div>
          <div
            className={`col-md-6 order-3 order-md-2 d-flex justify-content-start justify-content-md-end ${style.addRoleBtnWrapper}`}
          >
            {checkIfPermitted(Permissions.CREATE_APPOINTMENT) && (
            <Link to="/app/createappointment">
              <Button color="primary" className={style.addBtn}>
                <i className="fa fa-plus mr-2"></i>Create Appointment
              </Button>
            </Link>
            )}
          </div>
        </div>
        <div className="row">
        <div className="col-md-12 order-2 order-md-3">
            <p className="mb-4">
            All the Appointments scheduled on the system are listed here. Each Appointment may be edited, viewed or deleted.
            </p>
          </div>
        </div>
        <div className="row">
          {/* <div className="col-md-7 d-flex flex-wrap justify-content-center justify-content-md-start"> */}
          <div class="col-md-3 justify-content-center justify-content-md-start">
              <div className="form-group">
                <input
                  type="text"
                  className={`form-control ${style.inputSearch}`}
                  id="search"
                  placeholder="Search here"
                  value={this.state.searchKey}
                  onChange={this.onSearchChange}
                />
              </div>
            </div>
            {/* <div class="d-flex">
              <div>
                <label class="form-control border-0">in</label>
              </div>
              <div class="form-group">
                <select
                  className="form-control"
                  id="searchIn"
                  onChange={this.selectChange}
                >
                  <option value="all">All</option>
                  <option value="related_party_name">Contact</option>
                  <option value="doctor_name">Doctor/Professional</option>
                  <option value="room_name">Room</option>
                  <option value="appointment_status">Status</option>
                </select>
              </div>
            </div> */}
              <div class="col-md-2 justify-content-center justify-content-md-start">
              <div className="form-group">
                        <DatePicker
                          name="dateFrom"
                          onChange={this.handleDateFrom}
                          placeholder="Date From"
                          className="form-control"
                          value={this.state.dateFrom}
                          disabledDate={(d) => !d || d.isAfter(this.state.dateTo)}
                        />
                      </div>
              </div>
              <div class="col-md-2 justify-content-center justify-content-md-start">
                    <div className="form-group">
                          <DatePicker
                            name="dateTo"
                            onChange={this.handleDateTo}
                            placeholder="Date To"
                            className="form-control"
                            value={this.state.dateTo}
                            disabledDate={(d) => !d || d.isBefore(this.state.dateFrom)}
                          />
                        </div>
                </div>
          {/* </div> */}
          <div className="col-md-5 justify-content-center justify-content-md-start">
          <div class="form-group">
                <select
                  className="form-control"
                  id="appointment_status_id"
                  onChange={this.selectAppointmentStatus}
                  value={this.state.lk_appointment_status_id}
                >
                  <option value="">Select Status</option>
                 {appointmentStatusOptions}
                </select>
              </div>
          </div>  
          </div>
          <div className="row mb-1">
            <div className="col-md-2 order-3 order-md-2 justify-content-start justify-content-md-end">
              <p className={style.clearFilters} onClick={this.clearFilters}>Clear Filters</p>
            </div>
          <div className="col-md-10 order-3 order-md-2 d-flex justify-content-start justify-content-md-end">
            <div className={style.advFilterBtnWrapper}>
              {/* <button onClick={this.toggle}>Advanced filter</button> */}
              <span className={style.advFilterLabel}>Advanced Filter</span>
              <img
                src={filterImage}
                alt="Advanced filter"
                onClick={this.toggle}
                className={style.advFilterImg}
              />
            </div>
          </div>
        </div>
        <div className={style.advFilterWrapper}>
          <Collapse isOpen={this.state.isOpen}>
            <Card>
              <CardBody>
                <div className={style.closeWrapper}>
                  <i
                    className={`fa fa-times ${style.close}`}
                    aria-hidden="true"
                    onClick={this.toggle}
                  ></i>
                </div>
                <div className="row">
                  <div className="col-lg-5">
                    <div>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          className="custom-control-input"
                          id="scheduler"
                          name="filterBy"
                          value="scheduler"
                          onChange={this.handleOptionChange}
                          checked={this.state.filterBy === "scheduler"}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="scheduler"
                        >
                          Scheduler
                        </label>
                      </div>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          className="custom-control-input"
                          id="professional"
                          name="filterBy"
                          value="doctor_name"
                          onChange={this.handleOptionChange}
                          checked={this.state.filterBy === "doctor_name"}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="professional"
                        >
                          Doctor/Professional
                        </label>
                      </div>
                      <div className="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          className="custom-control-input"
                          id="room"
                          name="filterBy"
                          value="room_name"
                          onChange={this.handleOptionChange}
                          checked={this.state.filterBy === "room_name"}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="room"
                        >
                          Room
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-5">
                        <label>Choose the filter name:</label>
                      </div>
                      <div className="col-lg-5">
                        <div className="form-group">
                          <select
                            className="form-control"
                            id="filterName"
                            name="filterName"
                            onChange={this.nameOnChnage}
                          >
                            <option value="">Select</option>

                            {this.state.filterBy === "scheduler" &&
                              this.state.advFilterDropdownData &&
                              this.state.advFilterDropdownData.map(
                                (element, index) => (
                                  <option key={index} value={element.user_id}>
                                    {element.name}
                                  </option>
                                )
                              )}

                            {this.state.filterBy === "doctor_name" &&
                              this.state.advFilterDropdownData &&
                              this.state.advFilterDropdownData.map(
                                (element, index) => (
                                  <option
                                    key={index}
                                    value={element.related_party_id}
                                  >
                                    {element.name}
                                  </option>
                                )
                              )}
                              {this.state.filterBy === "room_name" &&
                              this.state.advFilterDropdownData &&
                              this.state.advFilterDropdownData.map(
                                (element, index) => (
                                  <option
                                    key={index}
                                    value={element.room_id}
                                  >
                                    {element.room_name}
                                  </option>
                                )
                              )}
                          </select>
                        </div>
                      </div>
                        <div className="col-lg-2">
                          <button
                            type="button"
                            className={`tmed-btn tmed-primary-btn ${style.goBtn}`}
                            onClick={this.advFilterSubmit}
                          >
                            GO
                          </button>
                       </div>
                    </div>
                  </div>
                </div> 
                  <div className="row">
                    <div className="col-lg-12">
                      {this.state.filterError && (  
                      <p className="error">{this.state.filterError}</p>
                      )}
                    </div>
                  </div>               

              </CardBody>
            </Card>
          </Collapse>
        </div>
        <BootstrapTable
          bordered={false}
          remote={true}
          data={this.state.appointmentList}
          version="4"
          search={false}
          pagination
          fetchInfo={{
            dataTotalSize: this.props.appointmentListData.appointmentList.total,
          }}
          options={{
            sortName: this.state.sortName,
            sortOrder: this.state.sortOrder,
            onSortChange: this.onSortChange,
            onSearchChange: this.onSearchChange,
            sizePerPage: 10,
            page: this.state.page,
            onPageChange: this.onPageChange,
            noDataText: this.setLoader(),
          }}
        >
          <TableHeaderColumn
            dataField="related_party_name"
            isKey
            dataSort={true}
            width="20%"
            dataFormat={(cell, row)=>this.nameFormatter(cell, row)}
          >
            Contact
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="doctor_name"
            dataSort={true}
            width="20%"
          >
            Doctor/Professional
          </TableHeaderColumn>

          <TableHeaderColumn dataField="room_name" dataSort={true} width="10%">
            Room
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="appointment_date"
            dataSort={true}
            width="20%"
            dataFormat={(cell)=>this.appointmentDateFormatted(cell)}
          >
            Appointment Date
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="appointment_status"
            dataSort={true}
            width="30%"
          >
            Status
          </TableHeaderColumn>

          { (checkIfPermitted(Permissions.EDIT_APPOINTMENT) || 
          checkIfPermitted(Permissions.DELETE_APPOINTMENT))  &&  (
          <TableHeaderColumn
            dataField="actions"
            dataFormat={this.actionsFormatter.bind(this)}
            width="10%"
          >
            Actions
          </TableHeaderColumn>)}
        </BootstrapTable>

        {/* Open a modal for delete Appointment */}
        <Modal
          isOpen={this.state.isDeleteModalOpen}
          toggle={this.toggleDeleteModal}
          className={style.deleteReason}
          centered
        >
          <ModalHeader
            toggle={this.toggleDeleteModal}
            className={style.deleteModalHeader}
          >
            Delete Appointment
          </ModalHeader>
          <ModalBody>
            {!this.state.errorMessage && (
              <div className={style.deleteReasonHeadingWrapper}>
                <p>
                  Please confirm whether you want to delete this appointment.
                </p>
              </div>
            )}
            <div className={style.deleteReasonFormWrapper}>
              <form>
                <div className={style.error}>{this.state.errorField}</div>

                {!this.state.errorMessage && (
                  <div className="row">
                    <div className={`col-md-12 ${style.deleteBtnWrapper}`}>
                      <button
                        type="button"
                        className="ttm-primary-btn"
                        onClick={this.onDeleteAppointment}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-md-12">
                    {this.state.successMessage && (
                      <p className={style.successMessage}>
                        {this.state.successMessage}
                      </p>
                    )}
                    {this.state.errorMessage && (
                      <p className={style.errorMessage}>
                        {this.state.errorMessage}
                      </p>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>

        {/* Open a Appointment  view */}
          
        <Modal
            isOpen={this.state.isModalOpenAppointment}
            toggle={this.toggleAppointmentView}
            className="viewProductDetailsModal"
            centered
          >
            {this.state.isAppointmentModalLoading ? (
            <div className={style.loadingWrapper}>
              <img src={ttmLodader} alt="modal-loader" className={style.loading} />
            </div>
          ) : (
          <React.Fragment>
            <ModalHeader
              toggle={this.toggleAppointmentView}
              className={style.deleteModalHeader}
            >
              Appointment Details
            </ModalHeader>
            <ModalBody>
              <div className={style.productviewDetailsWrapper}>
                <div className="row">
                  {/* <div className="col-md-12">
                    <h6 className={style.viewHeading}>Contact</h6>
                  </div> */}
                  <div className="col-md-3">
                    <p className="key">Appointment Type:</p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      {appoinmentDetailsData &&
                        appoinmentDetailsData.lk_appointment_type}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Details</h6>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Name of the Contact:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData && appoinmentDetailsData.name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Physical Address:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.physical_address
                            ? appoinmentDetailsData.physical_address
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Referrence Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.reference_id}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Phone Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.contact_number
                            ? appoinmentDetailsData.contact_number
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Email:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.email
                            ? appoinmentDetailsData.email
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Authorization Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.authorization_number
                            ? appoinmentDetailsData.authorization_number
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Referring Practitioner:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.requested_related_party_id
                            ? this.getRequestedProfessional(appoinmentDetailsData.requested_related_party_id)
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Room:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            this.getRoom(appoinmentDetailsData.room_id)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Appointment Reason:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            this.getAppointmentReason(appoinmentDetailsData.lk_appointment_reason_id)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Appointment Status:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            this.getAppointmentStatus(appoinmentDetailsData.lk_appointment_status_id)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Payment Type:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            (parseInt(appoinmentDetailsData.payment_type) === 1 ?"Pre-Payment":(
                              parseInt(appoinmentDetailsData.payment_type) === 2 ?"Post-Payment":"Not Provided"))}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Notes:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            appoinmentDetailsData.notes ?
                            appoinmentDetailsData.notes : "Not Available"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />

                {appoinmentDetailsData && appoinmentDetailsData.appointment_date && (
                <div className="row">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Appointment Date(s)</h6>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                      {this.renderScheduledDates(appoinmentDetailsData.appointment_date)}
                      </div>
                    </div>
                  </div>
                </div>)}
                <hr />

                  {checkIfPermitted(Permissions.MANAGE_LETTERS) &&(
                  <div className="row">
                    <div className="col-md-12">
                      <h6 className={style.viewHeading}>Attached Document(s)</h6>
                    </div>
                    <div className="col-md-12">
                      <div className="row mb-2">
                      <div className="col-md-12">
                          {appoinmentDetailsData && 
                          appoinmentDetailsData.conductAppointmentNotes && appoinmentDetailsData.conductAppointmentNotes.length > 0 &&
                          appoinmentDetailsData.conductAppointmentNotes.map((element, index) => (
                            
                                <span key={element.conductappointment_notes_id}
                                class={`${style.caseFileWrapper} mr-3`}
                                 onClick={(e) =>
                                      this.downloadFile(
                                        element.appointment_id,
                                        element.lk_document_type_id
                                      )
                                    }>
                                  <i
                                    className={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}
                                  ></i>
                                  {/* <span>{element.lk_document_type_id === 1 ? "Doctor Note": element.lk_document_type_id === 2 : "Referral Note" : ""}</span> */}
                                  <span>
                                    {element.lk_document_type_id === 1
                                      ? "Doctor Note"
                                      : element.lk_document_type_id === 2
                                      ? "Referral Note"
                                      : "Prescription"}
                                  </span>
                                </span>
                            ))}
                          {(appoinmentDetailsData && ((appoinmentDetailsData.conductAppointmentNotes &&
                            appoinmentDetailsData.conductAppointmentNotes.length === 0)|| 
                            !appoinmentDetailsData.conductAppointmentNotes)) && (                            
                              <p>No attached documents found</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>)}

                <hr />
                
                {appoinmentDetailsData 
                && appoinmentDetailsData.isPatientFile && (
                <div className="row">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Patient File</h6>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-12">
                      <span
                                class={style.caseFileWrapper}
                                onClick={()=>this.onDownloadSubmitFile(appoinmentDetailsData)}
                              >
                                <i
                                  class={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}
                                ></i>
                                {appoinmentDetailsData && 
                                  appoinmentDetailsData.file_number && (<span> {`${appoinmentDetailsData && 
                                  appoinmentDetailsData.file_number}.pdf`} </span>)}

                                  {appoinmentDetailsData && 
                                  !appoinmentDetailsData.file_number && (<span> {`${appoinmentDetailsData && 
                                  appoinmentDetailsData.name}.pdf`} </span>)}
                              </span>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                <div className="row">
                  <div className="col-md-12">
                    {this.state.isCaseFileDownloading  ? (
                      <div className={style.loadingWrapper}>
                        <img src={ttmLodader} className={style.loading} />
                      </div>
                    ) : (
                      <div>
                        {this.state.successMessage && (
                          <p className={style.successMessage}>
                            {this.state.successMessage}
                          </p>
                        )}
                        {this.state.errorMessage && (
                          <p className={style.errorMessage}>
                            {this.state.errorMessage}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ModalBody>
              </React.Fragment>
        )}
          </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appointmentListData: state.appointmentList,
    advFilterListData: state.AdvFilterList,
    dropdownListData: state.dropdownList, 
    appointmentDetailsData: state.appointmentDetails,
    appointmentDropdownData: state.appointmentDropdown,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDropdownList: ()=> dispatch(fetchDropdownList()),
    fetchAppointmentDetails: (appointment_id)=> dispatch(fetchAppointmentDetails(appointment_id)),
    fetchAppointmentList: (payload, queryString, sortBy, page, appointmentStatus, isTodaysAppointmentist, isWaitingList,outstandingInvoices,pastAppointmentCount) =>
      dispatch(fetchAppointmentList(payload, queryString, sortBy, page, appointmentStatus, isTodaysAppointmentist, isWaitingList,outstandingInvoices,pastAppointmentCount)),
    fetchAdvFilteList: () => dispatch(fetchAdvFilteList()),
    fetchAppointmentDropdown: () => dispatch(fetchAppointmentDropdown()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppoinmentList);
